import { MruCache } from 'owa-mru-cache';
import type ConversationItemParts from './schema/ConversationItemParts';
import shouldReduceMemoryForDevice from '../utils/shouldReduceMemoryForDevice';

export type ConversationMruCache = MruCache<ConversationItemParts>;

type ConversationCacheReferenceGetter = () => string | string[];

let conversationCache: ConversationMruCache | null = null;
let pendingReferenceGetters: ConversationCacheReferenceGetter[] = [];

export function registerConversationCacheReference(
    referenceGetter: ConversationCacheReferenceGetter
): void {
    if (conversationCache) {
        conversationCache.registerReference(referenceGetter);
    } else {
        pendingReferenceGetters.push(referenceGetter);
    }
}

export default function getConversationCache(): ConversationMruCache {
    if (conversationCache == null) {
        const cacheSize = shouldReduceMemoryForDevice() ? 10 : 50;
        conversationCache = new MruCache<ConversationItemParts>('ConversationItemParts', cacheSize);
        for (const referenceGetter of pendingReferenceGetters) {
            conversationCache.registerReference(referenceGetter);
        }
        pendingReferenceGetters = [];
    }
    return conversationCache;
}
